import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { CustomDatePipe } from '../../shared/utils/date.pipe';
import { LicenceSchool } from './licence-school.model';
import { LicenceSchoolService } from './licence-school.service';


@Component({
    selector: 'jhi-licence-school-detail',
    templateUrl: './licence-school-detail.component.html'
})
export class LicenceSchoolDetailComponent implements OnInit, OnDestroy {

    licenceSchool: LicenceSchool;
    private subscription: Subscription = new Subscription();

    constructor(
        private licenceSchoolService: LicenceSchoolService,
        private route: ActivatedRoute,
        private datePipe: CustomDatePipe
    ) {
    }

    ngOnInit() {
        this.subscription.add(this.route.params.subscribe(params => {
            this.load(params['id']);
        }));

    }

    load (id) {
        this.subscription.add(this.licenceSchoolService.find(id).subscribe(licenceSchool => {
            licenceSchool.createdDate = this.datePipe.transform(licenceSchool.createdDate);
            licenceSchool.lastModifiedDate = this.datePipe.transform(licenceSchool.lastModifiedDate);
            this.licenceSchool = licenceSchool;
        }));
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/licence-school/licence-school-detail.component.ts